import { AlertCircle } from "lucide-react";

interface ErrorAlertProps {
  message: string;
  variant?: "error" | "warning";
  className?: string;
}

export function ErrorAlert({
  message,
  variant = "error",
  className = "",
}: ErrorAlertProps) {
  const styles = {
    error: "bg-red-50 border-red-700/20 text-red-700",
    warning: "bg-yellow-50 border-yellow-400/20 text-primary-dark",
  };

  return (
    <div
      className={`flex items-center gap-2 p-3 border rounded-xl text-sm ${styles[variant]} ${className}`}
    >
      <AlertCircle className="w-4 h-4 flex-shrink-0" />
      <span>{message}</span>
    </div>
  );
}

